import { Component, Input, OnChanges } from "@angular/core";
import { Chart } from "chart.js/auto";
import { ObservationResponseAllDto } from "../../../../../common/dtos/observation/observation.response.all";

@Component({
  selector: "app-bar-chart",
  templateUrl: "./bar-chart.component.html",
  styleUrls: [
    "./bar-chart.component.scss"
  ]
})
export class BarChartComponent implements OnChanges {

  public chart: Chart | null = null;
    @Input() data: ObservationResponseAllDto | undefined;
    categoryLSRCounts: number[] = [];
    categoryDPICounts: number[] = [];
    categoryALCounts: number[] = [];
    categorySECCounts: number[] = [];

    ngOnChanges(): void {
      if (this.data) {
        this.createChart(this.data);
      }
    }

    createChart(result: ObservationResponseAllDto) {
      const countMap: { [key: string]: number } = {};

      result.content.forEach((item) => {
        const references = item.refString?.split("-").map((ref) => ref.trim());

        references?.forEach((ref) => {
          countMap[ref] = (countMap[ref] || 0) + 1;
        });

      });
      const labels = Object.keys(countMap);
      const values = Object.values(countMap);

      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart("BarChart", {
        type: "bar",
        data: {
          labels,
          datasets: [
            {
              label: "Observation References",
              data: values,
              backgroundColor: "orange"
            }
          ]
        },
        options: {
          aspectRatio: 2.5
        }
      });
    }

    private readonly categoryLSRList = [
      "UNSAFE DRIVING",
      "HAZARDOUS EXCAVATION / NOT BARRICADED",
      "UNSAFE LIFTING",
      "WORK AT HEIGHT",
      "MANAGEMENT OF CHANGE (MOC)",
      "FIRE RISK / HOT WORK",
      "CONFINED SPACE",
      "FAILURE TO FOLLOW PTW REQUIREMENTS",
      "WORK IN UNSAFE POSITION (LINE OF FIRE)",
      "LOCK OUT / TAG OUT NOT PERFORMED"
    ];

    private readonly categoryDPIList = [
      "INADEQUATE / LACK OF PPE GLASSES",
      "INADEQUATE / LACK OF PPE HELMET",
      "INADEQUATE / LACK OF PPE EAR PROTECTION",
      "INADEQUATE / LACK OF PPE GLOVES",
      "INADEQUATE / LACK OF PPE SAFETY HARNESS",
      "INADEQUATE / LACK OF PPE SAFETY SHOES",
      "INADEQUATE / LACK OF PPE RESPIRATORY PROTECTION",
      "INADEQUATE / LACK OF PPE OTHER PPE"
    ];

    private readonly categoryALList = [
      "GOOD WORKING PRACTICES / BEHAVIOR",
      "ABSENCE OF SUPERVISOR  - FOREMAN",
      "UNSAFE STORAGE",
      "ILLUMINATION",
      "UNEXPERIENCED WORKER (NEEDS TUTOR)",
      "LACK OF SPECIFIC TRAINING FOR THE ACTIVITY",
      "LACK OF ADEQUATE EQUIPMENT",
      "LACK OF KNOWLEDGE ABOUT EMERGENCY PROCEDURES",
      "LACK OF SIGNS",
      "FAILURE TO FOLLOW INSTRUCTIONS",
      "NOT ERGONOMIC POSITION",
      "INADEQUATE HOUSEKEEPING",
      "SLIP - TRIP - FALL RISK",
      "ELECTRICAL RISK",
      "DELIMITATION / FENCING OF AREAS / SIGNAGE",
      "NOT CORRECT MANUAL LIFTING",
      "CHEMICAL SUBSTANCES",
      "EXTREME WEATHER",
      "TOOL - BOX PERFORMED / NOT PERFORMED",
      "ALL IN GOOD CONDITIONS"
    ];

    private readonly categorySECList = [
      "SECURITY"
    ];

}

